import { FC } from "react";
import { useBreakpoints } from "@jobber/hooks/useBreakpoints";

const ProXtraPromotionalPanel: FC = () => {
    const { mediumAndUp } = useBreakpoints();

    return (
        <div
            style={{
                maxWidth: mediumAndUp ? "40%" : "100%",
                flexShrink: 0,
                borderRadius: "var(--radius-base)",
                overflow: "hidden",
            }}
        >
            <img
                src="/proxtra_screenshot.png"
                alt="Pro Xtra custom pricing in Jobber catalog"
                style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    borderRadius: "var(--radius-base)",
                }}
            />
        </div>
    );
};

export default ProXtraPromotionalPanel;
